import Cache from '@fs/zion-cache'
import CacheService from '@fs/zion-cache-service'

const tenSecondLifeTime = 10000

export const cacheOld = new Cache({
  storeName: 'group_management',
  type: 'memory',
  lifetime: tenSecondLifeTime,
})

export const cacheServiceOld = new CacheService({
  cache: cacheOld,
  strategy: 'cache-first',
})

export const cache = new Cache({
  storeName: 'groupManagementAppServices',
})

export const cacheService = new CacheService({
  cache,
  strategy: 'cache-and-network',
})
